import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DictionaryService } from 'app/mdm/terminology/dictionary/services/dictionary.service';
import { Dictionary, DictionaryVersion } from 'app/mdm/terminology-lib/services/dictionary';
import { MessageService } from '@heda/core-hospital-ui';

@Component({
  templateUrl: './dictionary-view.component.html',
})
export class DictionaryViewComponent implements OnInit {
  public dictionary: Dictionary;
  public versions: DictionaryVersion[];
  public twoVersionsSelected = false;

  constructor(
    private dictionaryService: DictionaryService,
    private translateService: TranslateService,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    this.dictionaryService.getDictionary(id).subscribe((r) => (this.dictionary = r));
    this.dictionaryService.getVersions(id).subscribe((r) => (this.versions = r));
  }

  addVersion(dictionaryId: string): void {
    this.dictionaryService.createVersion(dictionaryId, {} as DictionaryVersion).subscribe((r) => {
      this.router.navigate(['/dictionaries', this.dictionary.id, 'versions', 'view', r.version]);
    });
  }

  copyVersion(dictionaryId: string, version: number): void {
    this.dictionaryService.copyVersion(dictionaryId, version).subscribe(
      () => {
        this.loadVersions(dictionaryId);
      },
      (err) => this.messageService.error('term.di-03.versions.msg.error.copy')
    );
  }

  publishVersion(dictionaryId: string, version: number): void {
    this.dictionaryService.publishVersion(dictionaryId, version).subscribe(
      () => {
        this.loadVersions(dictionaryId);
      },
      (err) => this.messageService.error('term.di-03.versions.msg.error.publish')
    );
  }

  deleteVersion(dictionaryId: string, version: number): void {
    this.dictionaryService.deleteVersion(dictionaryId, version).subscribe(
      () => {
        this.loadVersions(dictionaryId);
      },
      (err) => this.messageService.error('term.di-03.versions.msg.error.delete')
    );
  }

  loadVersions(id: string): void {
    this.dictionaryService.getVersions(id).subscribe((r) => (this.versions = r));
  }

  compareVersions(): void {
    const versionNumbers = this.versions.filter((v) => v['checked']).map((v) => v['version']);
    this.router.navigate([
      '/dictionaries',
      this.dictionary.id,
      'versions',
      'diff',
      versionNumbers[0],
      versionNumbers[1],
    ]);
  }

  checkboxesRefreshed(): void {
    const checks = this.versions.filter((v) => v['checked']).length;
    if (checks === 2) {
      this.versions.forEach((v) => {
        if (!v['checked']) {
          v['disabled'] = true;
        }
      });
      this.twoVersionsSelected = true;
    } else {
      this.versions.forEach((v) => {
        v['disabled'] = false;
      });
      this.twoVersionsSelected = false;
    }
  }

  goBack(): void {
    this.location.back();
  }
}
